import { useJourneyStore, selectCurrentStage } from "../game/state/journeyMachine";
import { EVIDENCE_TAG_LABELS } from "../data/evidenceTags";

/**
 * Fuentes primarias verificadas en la investigación normativa
 * (docs-3d/research/INVESTIGACION_NORMATIVA.md).
 */
const PRIMARY_SOURCES: readonly { label: string; url: string }[] = [
  {
    label: "Resolución 37125 de 2025 (MinTransporte) — esquema CALE",
    url: "https://mintransporte.gov.co/info/mintransporte/media/anexos/Cm0eM2qD.pdf",
  },
  {
    label: "Anexo 60 de la Res. 37125/2025 — procesos y metodología de evaluación",
    url: "https://enlegislacion.com/files/susc/cdj/conc/anexo_60.pdf",
  },
  {
    label: "Resolución 8150 de 2026 (Supertransporte) — SICOV-CALE",
    url: "https://alphasig.metropol.gov.co/normograma/compilacion/docs/resolucion_supertransporte_8150_2026.htm",
  },
  {
    label: "Circular Externa 20261010000317 de 2026 — aplazamiento de la exigibilidad",
    url: "https://mintransporte.gov.co/loader.php?lServicio=Tools2&lTipo=descargas&lFuncion=descargar&idHash=E41BWZ5A02dgFuibfvXo8jpqMnM0RU1pag",
  },
  {
    label: "Resolución 45295 de 2022 (textos derogados, linaje normativo)",
    url: "https://www.cancilleria.gov.co/sites/default/files/Normograma/docs/pdf/resolucion_mintransporte_45295_2022.pdf",
  },
];

export function SourcesPanel() {
  const sourcesOpen = useJourneyStore((s) => s.sourcesOpen);
  const setSourcesOpen = useJourneyStore((s) => s.setSourcesOpen);
  const stage = useJourneyStore(selectCurrentStage);

  if (!sourcesOpen) return null;

  return (
    <aside
      role="complementary"
      aria-label="Fuentes y soporte"
      className="fixed right-0 top-0 z-40 h-full w-full max-w-sm overflow-auto border-l border-[var(--cale-border)] bg-[var(--cale-surface-raised)] p-6 shadow-[var(--shadow-panel)]"
    >
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold">Fuentes</h2>
        <button
          type="button"
          onClick={() => setSourcesOpen(false)}
          aria-label="Cerrar panel de fuentes"
          className="rounded-md px-2 py-1 text-sm hover:bg-[var(--cale-surface)]"
        >
          ✕
        </button>
      </div>
      <p className="mt-4 text-sm font-medium">{stage.title}</p>
      <p className="mt-1 text-sm">Etiqueta probatoria: {EVIDENCE_TAG_LABELS[stage.tag]}</p>
      <p className="mt-2 text-sm text-[var(--cale-ink-muted)]">{stage.source}</p>
      <h3 className="mt-6 text-sm font-semibold">Fuentes primarias</h3>
      <ul className="mt-2 flex flex-col gap-2">
        {PRIMARY_SOURCES.map((s) => (
          <li key={s.url}>
            <a
              href={s.url}
              target="_blank"
              rel="noreferrer"
              className="text-sm text-[var(--cale-accent)] underline underline-offset-2 hover:text-[var(--cale-accent-strong)]"
            >
              {s.label}
            </a>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-xs text-[var(--cale-ink-muted)]">
        Documento de investigación interno: docs-3d/research/INVESTIGACION_NORMATIVA.md. Verificar siempre
        contra el texto oficial vigente en mintransporte.gov.co y funcionpublica.gov.co.
      </p>
    </aside>
  );
}
